import styled from "styled-components";

import { CalendarProps } from "@/components/ui/Calendar/Calendar";

export const CalendarContainer = styled.div<CalendarProps>`
  display: block;
  position: relative;
  margin-bottom: ${({ $marginbottom }) => $marginbottom};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? "none" : "auto")};
  // width: auto;
  // width: 100%;
  width: ${({ width }) => width ?? "auto"};

  // z-index: 1;

  label {
    font-size: 0.875rem;
    color: var(--inputLabelColor, #000);
    font-weight: 500;
    text-align: left;
    display: flex;
    align-items: center;
    line-height: 1;
    gap: 0.125rem;
    margin-bottom: 0.5rem;
    ${({ required }) =>
      required
        ? `
      &::after {
        content: '*';
        color: red;
        padding-left: 0px;
      }
      `
        : ""}
  }

  .react-datepicker-wrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    min-width: ${({ $minWidth }) => $minWidth};
    border: ${({ border, $isDisabled }) => `1px solid ${$isDisabled ? "var(--disabledInput, #f5f5f5)" : border} `};
    background-color: ${({ $backgroundColor, $isDisabled }) =>
      $isDisabled ? "var(--disabledInput, #f5f5f5)" : ($backgroundColor ?? "var(--inputBgColor, transparent)")};
    border-radius: 0.625rem;
    padding: 0 1rem;
    cursor: pointer;

    .clearButton {
      display: flex;
      justify-content: center;
      align-items: center;
      // background-color: white;
      // width: 1.5rem;
      // height: 1.5rem;

      &::after {
        background-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'%3E%3Cpath fill='%23218359' d='M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 0 0-1.4 1.4L10.6 12l-4.9 4.9a1 1 0 0 0 1.4 1.4L12 13.4l4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z'/%3E%3C/svg%3E");
         position: absolute;
        top: 50%;
        transform: translate(0%, -50%);
        right: 1.5rem;
      }
    }

    svg {
      padding: 0;
      top: 50%;
      right: 0%;
      transform: translate(0%, -50%);
    }

    button {
      padding: 0;
      top: 50%;
      right: 0%;
      transform: translate(0%, -50%);
      z-index: 10;
      cursor: pointer;
    }

    input {
      width: 100%;
      padding-left: 0rem;
      border: none;
      outline: none;
      background-color: transparent;
      color: ${({ $isDisabled }) => ($isDisabled ? "var(--neutral400, #b3b3b3)" : "var(--neutral1, #000000)")};
      cursor: pointer;

      &::placeholder {
        color: ${({ $placeholderColor }) => $placeholderColor ?? "var(--neutral3, #828282)"};
      }
    }

    .react-datepicker__calendar-icon {
      // width: 1.125rem;
      // height: 1.125rem;
    }
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker {
    border: ${({ border }) => `1px solid ${border ?? "var(--primary)"} `};
    border-radius: 0.625rem;
    padding: 0.125rem;

    .customHeader {
      margin-bottom: 0.25rem;
      display: flex;
      align-items: center;
      padding: 0.5rem 0.25rem;
      justify-content: space-between;
      width: 100%;
      gap: 1rem;

      button {
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 0.125rem;

        &:disabled {
          cursor: not-allowed;

          svg {
            path {
              fill: var(--neutral3, #828282);
              stroke: var(--neutral3, #828282);
            }
          }
        }
      }

      .yearAndMonthDropdowns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        flex: 1;

        select {
          font-size: 1rem;
          border: none;
          outline: none;
          background-color: var(--white, #fcfcfc);
          width: fit-content;
        }

        .yearCustomSelect {
          z-index: 10;
          min-width: 4rem;
        }

        .monthCustomSelect {
          z-index: 10;
        }

        .yearCustomSelect,
        .monthCustomSelect {
        cursor: pointer;

         option {
          cursor: pointer;
}          
        }
      }

      .navButtonsGroup {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        flex: 0 0 auto;
      }
    }

    .react-datepicker__month-container {
      .react-datepicker__header {
        background-color: var(--white, #fcfcfc);
        border: none;
        padding: 0;

        .react-datepicker__current-month,
        .react-datepicker__day-name {
          color: var(--neutral1, #000);
        }

        .react-datepicker__current-month {
          font-size: 1rem;
          margin-bottom: 0.5rem;
        }

        .react-datepicker__day-name {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 2.125rem;
          height: 2.125rem;
          margin: 0;
          font-size: 0.95rem;
          font-weight: 700;
          line-height: 1;
          letter-spacing: 0.01em;
        }
      }
    }

    .react-datepicker__day {
      font-size: 1rem;
      width: 2.125rem;
      height: 2.125rem;
      padding: 0.5rem;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .react-datepicker__week {
      .react-datepicker__day:nth-child(7) {
        color: var(--error, #eb5757);

        &.react-datepicker__day--selected {
          color: var(--white, #fcfcfc);
        }
      }
    }

    .react-datepicker__day--selected {
      background-color: var(--primary, #951F39) !important;
      color: var(--white, #fcfcfc) !important;
    }

    // This is disabled because it is causing unwanted behavior
    // .react-datepicker__day--keyboard-selected {
    //   background-color: var(--primary, #2d9cdb) !important;
    //   color: var(--white, #fcfcfc) !important;
    // }

    .react-datepicker__day--highlighted {
      background-color: transparent;
      color: inherit;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 0%;
        right: 0.125rem;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background-color: var(--error, #f1ab86);
      }
    }
  }

  .error {
    font-size: 12px;
    color: var(--error, #eb5757);
    position: absolute;
    left: 0;
    text-align: left;
    padding: 0.125rem 0px 0px 0px;
    margin: 0px;
    line-height: 1;
  }
`;
